<template>
  <div id="transmision_manifestacion">
    <div>
      <v-breadcrumbs :items="breadcrumbs">
        <v-icon slot="divider">forward</v-icon>
      </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12>
          <base-material-card color="primary" icon="library_books" title="Layouts - Complementos MVe"
            class="elevation-1 px-5 py-3">
            <v-card-text>
              <v-form ref="formreporte" lazy-validation>
                <v-container grid-list-md text-xs-center>

                  <v-row row wrap>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary"
                            prepend-icon="event" @blur="
                              model.fecha_de = parseDate(model.fecha_de)
                              " v-mask="'####-##-##'" :rules="[
                                rules.required,
                                validaDias,
                                validaFecha,
                                $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                              ]">
                          </v-text-field>
                        </template>

                        <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu1 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu1 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col sm="12" md="4" lg="4">
                      <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition"
                        min-width="290px" offset-y>
                        <template v-slot:activator="{ on }">
                          <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary"
                            prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                              rules.required,
                              validaDias,
                              validaFecha,
                              $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                            ]"></v-text-field>
                        </template>
                        <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx"
                          @input="menu2 = false">
                          <v-spacer />

                          <v-btn color="secondary" large @click="menu2 = false">
                            Cancelar
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col sm="12" md="2" lg="2">
                      <v-switch v-model="fecha_factura" color="red darken-3" label="Fecha de Pedimento"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row>
                   <v-col sm="12" md="6" lg="6">
                
                   <v-autocomplete :hide-no-data="true" :items="rfcs_consulta" v-model="model.patente" :item-text="getNombreRfcConsulta" item-value="patente" 
                        label="Patente"></v-autocomplete>
                  </v-col>
                   <v-col sm="12" md="2" lg="2">
                  <v-text-field v-model="model.aduana" label="Aduana"   maxlength="3"></v-text-field>
                  </v-col>
                  <v-col sm="12" md="2" lg="2">
                      <v-btn rounded color="secondary" @click="cargar()">
                        <v-icon>mdi-download</v-icon>Consultar
                      </v-btn>
                    </v-col>
                  </v-row>

                </v-container>
              </v-form>

                  <v-refresh-button :funcion="cargarReportes" />
                  <v-client-table ref="vuetable" :data="datos.reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>



            </v-card-text>
          </base-material-card>
        </v-flex>
      </v-layout>
    </v-container>


  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";

import RefreshButton from "@/components/RefreshButton.vue";
import VistaPrevia from "@/views/manifestacion_valor/VistaPrevia.vue";

export default {
  components: { "v-refresh-button": RefreshButton, "v-vista-previa": VistaPrevia },
  created: function() {
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.URL = this.$hostname + "reportes/";
    this.loading = false;
    this.model.usuario = this.$local_storage.get("id_usuario");
    this.model.rfc = this.$local_storage.get("rfc");
    this.cargarReportes();
    this.cliente = this.$local_storage.get("id_cliente");
    this.cargarRfcsConsulta();
  },
  data: () => ({

  datos: {
      reportes: []
    },
    cliente:0,
    fecha_factura: true,
    rfcs_consulta:[],
    menu1: false,
    menu2: false,
    columns_reportes: ["id", "fecha_solicitud", "usuario_email", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options_reportes: {
      filterable: ["id", "fecha_solicitud", "usuario_email",  "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email",  "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
     model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      patente: "",
      aduana: "",
      nombre_reporte: "Layouts-Complementos-MVe",
      tipo: "MVe-Prellenado",
    },
    loading: false,
    show_loading: true,
    rules: {
  required: v => !!v || "Este campo es requerido",
    email: value => {
      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return pattern.test(value) || "Correo electrónico no valido";
    },
    },

URL: "",

  breadcrumbs: [{
    text: "Inicio",
    disabled: false,
    to: "/home"
  },
  {
    text: "EManifiesto",
    disabled: true,
    to: ""
  },
  {
    text: "Layouts Complementos MVe",
    disabled: true,
    to: ""
  }
  ],





  }),

methods: {


  validaDias: function () {
    if (this.model.fecha_de != "" && this.model.fecha_a != "") {
      var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
      var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
      var diferencia = fin.diff(inicio, "days");
      if (diferencia < 0)
        return "La Fecha Final no debe ser menor a la Fecha Inicial.";
      if (Math.abs(diferencia) > 31)
        return "Periodo máximo de consulta 31 dias. Favor de verificar.";
    }
    return true;
  },
 getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          var result = ""
          if (params.pedimento !=null && params.pedimento != "")
            result += "\nPedimento: " + params.pedimento;
          else {
            if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
              result += "Búsqueda por Lista.";
            } else {
              result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

            }
            if (params.patente != undefined && params.patente != "")
              result += " Patente: " + params.patente ;
            if (params.aduana != undefined && params.aduana != "")
              result += " Aduana: " + params.aduana;
          }


          return result;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },
  validaFecha: function (fecha) {
    if (fecha == "Invalid date")
      return "Fecha no válida.";
    else
      return true;
  },
  validaAnio: function () {
    if (this.model_nuevo.model.fecha_de != "" && this.model_nuevo.model.fecha_a != "") {
      var inicio = moment(this.model_nuevo.model.fecha_de, "YYYY-MM-DD");
      var fin = moment(this.model_nuevo.model.fecha_a, "YYYY-MM-DD");
      var diferencia = fin.diff(inicio, 'days')
      if (diferencia < 0)
        return "La Fecha Final no debe ser menor a la Fecha Inicial."
      if (inicio.year() > moment().year() || fin.year() > moment().year())
        return "Las fechas no deben ser mayor al año actual."
    }
    return true;
  },
 downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
            });
        }
      });

    },

  parseDate(date) {
    //Formato  YYYY-MM-DD
    if (!date) return null;
    return moment(String(date)).format("YYYY-MM-DD");
  },
cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "MVe-Prellenado"
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (res.data != undefined) {
            this.datos.reportes = res.data;
            this.datos.reportes.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos.reportes) {
              this.datos.reportes[k].fecha_solicitud = this.parseDate(this.datos.reportes[k].fecha_solicitud);
              this.datos.reportes[k].fecha_generacion = this.parseDate(this.datos.reportes[k].fecha_generacion);
              this.datos.reportes[k].estatus = this.getEstatus(this.datos.reportes[k].estatus);
              this.datos.reportes[k].criterio = this.getCriterioPredeterminadosDS(this.datos.reportes[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
  getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
     cargarRfcsConsulta: function () {
      var datos = {
        cliente: this.cliente
      };
      axios
        .post(this.$hostname + "catalogos/agentes_aduanales/get_agentes/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.rfcs_consulta = res.data;
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los rfcs de consulta.",
            footer: ""
          });
        });
    },
    getNombreRfcConsulta: function (record) {
      return record.patente + " - " + record.nombre ;
    },
  cargar: function () {

    if (!this.$refs.formreporte.validate()) {
      //Alguna operación o mensaje
      //   console.log('entra aqui');
    } else {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

      let fecha = true;
      if (this.fecha_factura)
        fecha = false;
    

      var datos = {
        rfc: this.model.rfc,
        fecha_de: this.model.fecha_de,
        fecha_a: this.model.fecha_a,
        usuario: this.model.usuario,
        creacion: fecha
      };
      if(this.model.patente !="" ){
         datos["patente"] =this.model.patente;
      };

     if(this.model.aduana !="" ){
         datos["aduana"] =this.model.aduana;
      };



      axios
        .post(this.$hostname  + "manifestacion/prellenar_layouts/", datos)
        .then(res => {
          if (typeof res.data !== "undefined") {

              var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);
            this.$root.$dialogLoader.hide();
             this.cargarReportes();

          }
        })
        .catch(err => {

          console.log(err);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    }

  },

},

mounted: function () {

  var f = new Date();
  var f_de = new Date();
  f_de.setDate(f_de.getDate() - 15);


  let y_de = f_de.getFullYear();
  let m_de = f_de.getMonth() + 1;
  let d_de = f_de.getDate();

  if (m_de < 10)
    m_de = '0' + m_de;
  if (d_de < 10)
    d_de = '0' + d_de;

  let y = f.getFullYear();
  let m = f.getMonth() + 1;
  let d = f.getDate();


  if (m < 10)
    m = '0' + m;
  if (d < 10)
    d = '0' + d;


  this.model.fecha_a = y + "-" + m + "-" + d;
  this.model.fecha_de = y_de + "-" + m_de + "-" + d_de;

}
};
</script>
<style scoped>
.manual>table>tr {
  page-break-inside: avoid
}

.title-table {
  font-weight: bold !important;
  background-color: lightgray !important;
}

.manual>table {
  width: 100%;
  border-collapse: collapse;
}

.manual>table,
td {
  padding-left: 2px;
  border: 1px solid #282828;
  height: 20px;
}

.titulo-principal {
  font-size: 1.1rem !important;
  font-weight: bold;
}

.manual {
  margin: 0px;
  padding: 0px;
  /*height: auto;
    width: auto;
    background-color: #fff;*/
  text-align: justify;
  font-family: Arial;
  font-size: 0.90rem;
}

.elevation-1>>>.columnaError {
  white-space: normal !important;
  min-width: 300px !important;
  text-align: justify !important;
}
</style>
